
import auth from '../../services/auth';
import session from '../../services/session';
import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_TOKEN,
  USER_INFO
} from './types';

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY';
const isProduction = process.env.NODE_ENV === 'production';

const initialState = {
  authenticating: false,
  error: false,
  token: null,
  info: null
};

const getters = {
  isAuthenticated: state => !!state.token,
  userInfo: state => state.info
};

const actions = {
  login({ commit }, { username, password }) {
    console.log('store login');
    commit(LOGIN_BEGIN);
    return auth.login(username, password)
      .then(({ data }) => {
        commit(SET_TOKEN, data.key);
        console.log('getAccountDetails init', data.key);
      })
      .then(() => {
        commit(LOGIN_SUCCESS);
      })
      .catch(() => commit(LOGIN_FAILURE));
  },
  getInfo({ commit }){
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    return auth.getAccountDetails(token).then(info => {
      console.log('getAccountDetails end', info.data);
      commit(USER_INFO, info.data);
    });
  },
  logout({ commit }) {
    return auth.logout()
      .then(() => commit(LOGOUT))
      .finally(() => commit(REMOVE_TOKEN));
  },
  initialize({ commit }) {
    console.log('auth initialize');
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    const info = localStorage.getItem(USER_INFO);

    if (isProduction && token) {
      commit(REMOVE_TOKEN);
    }

    if (!isProduction && token) {
      commit(SET_TOKEN, token);
      commit(USER_INFO, info);
    }
  },
};

const mutations = {
  [LOGIN_BEGIN](state) {
    state.authenticating = true;
    state.error = false;
  },
  [LOGIN_FAILURE](state) {
    state.authenticating = false;
    state.error = true;
  },
  [LOGIN_SUCCESS](state) {
    state.authenticating = false;
    state.error = false;
  },
  [USER_INFO](state, info) {
    if (!isProduction) localStorage.setItem(USER_INFO, JSON.stringify(info));
    state.info = info;
  },
  [LOGOUT](state) {
    state.authenticating = false;
    state.error = false;
  },
  [SET_TOKEN](state, token) {
    if (!isProduction) localStorage.setItem(TOKEN_STORAGE_KEY, token);
    session.defaults.headers.Authorization = `Token ${token}`;
    state.token = token;
  },
  [REMOVE_TOKEN](state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    delete session.defaults.headers.Authorization;
    state.token = null;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};